import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/projects`;

class ProjectService extends ApiHelper {
    constructor(_url: string) {
        super(_url);
    }

    public getProjectList(body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.create(body, { name: "list" });
        } catch (e) {
            throw e;
        }
    }

    public getProjectDetails(id: number): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.getById(id);
        } catch (e) {
            throw e;
        }
    }

    public getProjectDetailsByCode(projCode: string): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/Bycode`;
            return super.getById(projCode);
        } catch (e) {
            throw e;
        }
    }

    public getProjStatusList(): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.get(undefined, { name: "GetProjStatusList" });
        } catch (e) {
            throw e;
        }
    }

    public createProject(body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.create(body);
        } catch (e) {
            throw e;
        }
    }

    public createMinimumProject(body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.create(body, { name: "Minimum" });
        } catch (e) {
            throw e;
        }
    }

    public updateProject(projectId: number, body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.update(body, projectId);
        } catch (e) {
            throw e;
        }
    }

        public updateProjectsBatch(body: any): Promise<IApiResponse | void> {
            try {
                this.url = `${url}/batch`;
                return super.create(body);
            } catch (e) {
                throw e;
            }
        }
    public updateProjectList(projectId: number, body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.update(body, projectId);
        } catch (e) {
            throw e;
        }
    }

    public updateMinimumProject(projectId: number, body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/Minimum`;
            return super.update(body, projectId);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }
    public removeProject(projectId: number): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
          return super.delete(projectId);
        } catch (e) {
          throw e;
        }
      }

}
const projectAPI = new ProjectService(url);
export default projectAPI;